<template>
  <el-container>
    <el-header style="height: 20px;">
      <span class="company" v-if="currentUser.person">亲爱的<span style="color: black">{{currentUser.person.name}}</span>，欢迎进入小禾订货平台！</span>
      <span class="company" v-else>亲爱的<span style="color: black">系统管理员</span>，欢迎进入小禾订货平台！</span>
      <el-button class="but3" size="small" style="margin-left: -10px" @click="logout">退出登录</el-button>
    </el-header>
    <el-divider class="div_top"></el-divider>
    <el-main class="main">
      <span class="text"><img class="three_lever" src="@/assets/images/icon_product.png" alt=""/>产品列表</span>
      <el-main class="query">
        <el-select v-model="selectedSale" @change="handleCheckedSaleChange" placeholder="请选择销售组织" clearable>
          <el-option v-for="saleOrg in saleOrgLists" :label="saleOrg.name" :key="saleOrg.id" :value="saleOrg.id"></el-option>
        </el-select>
        <el-select v-model="selectedGroup" @change="handleCheckedGroupChange" placeholder="请选择物料分类" clearable style="width:150px;margin-left: 10px">
          <el-option v-for="group in groupLists" :label="group.groupName" :key="group.groupNumber" :value="group.groupNumber"></el-option>
        </el-select>
        <el-select v-model="selectedLogo" @change="handleCheckedLogoChange" placeholder="请选择物料品牌" clearable style="width:150px;margin-left: 10px">
          <el-option v-for="logo in logoLists" :label="logo.logoName" :key="logo.logoName" :value="logo.logoName"></el-option>
        </el-select>
        <el-select v-model="selectedModel" @change="handleCheckedModelChange" placeholder="请选择物料规格" clearable style="width:150px;margin-left: 10px">
          <el-option v-for="model in modelLists" :label="model.model" :key="model.model+model.spec" :value="model.model"></el-option>
        </el-select>
        <el-input placeholder="按关键字筛选" prefix-icon="el-icon-search" v-model="keyword" @change="queryPageListByAll(1)" style="width: 150px;margin-left: 10px"></el-input>
        <el-button type="info" @click="resetData" style="margin-left: 10px">重置</el-button>

        <el-table :data="tableData" :stripe="true" :border="true" :fit="true" style="margin-top: 20px" v-loading="loading">
          <el-table-column prop="number" label="商品编码" width="160"></el-table-column>
          <el-table-column prop="name" label="商品名称" width="200"></el-table-column>
          <el-table-column prop="model" label="规格型号" width=""></el-table-column>
          <el-table-column prop="shortName" label="代号" width=""></el-table-column>
          <el-table-column prop="helpCode" label="助记码" width=""></el-table-column>
          <el-table-column prop="registeredMark" label="品牌" width=""></el-table-column>
          <el-table-column label="操作" fixed="right" width="200">
            <template slot-scope="scope">
              <el-button type="warning" icon="el-icon-plus" size="small" @click="handleAdd(scope.$index , scope.row)" v-if="scope.row.commerceVo.id === null">新增</el-button>
              <el-button type="success" icon="el-icon-edit" size="small" @click="handleAdd(scope.$index , scope.row)" v-if="scope.row.commerceVo.id === null">编辑</el-button>
              <el-button type="success" icon="el-icon-edit" size="small" @click="handleEdit(scope.$index , scope.row)" v-if="scope.row.commerceVo.id !== null">编辑</el-button>
              <el-button type="primary" icon="el-icon-delete" size="small" @click="handleDel(scope.$index , scope.row)" v-if="scope.row.commerceVo.id !== null">删除</el-button>
            </template>
          </el-table-column>

          <el-table-column type="expand">
            <template slot-scope="props">
              <el-form label-position="left" inline class="table-expand">
                <el-form-item label="商品名称:" style="margin-left: 20px">
                  <span v-if="props.row.commerceVo.name === null">{{''}}</span>
                  <span v-else style="font-weight: bold">{{props.row.commerceVo.name}}</span>
                </el-form-item>
                <el-form-item label="商品二级节点标识:" style="margin-left: 30px">
                  <span v-if="props.row.commerceVo.nodeIdentify === null">{{''}}</span>
                  <span v-else style="color: black">{{props.row.commerceVo.nodeIdentify}}</span>
                </el-form-item><br>
                <el-form-item label="头图:" style="margin-left: 20px">
                  <el-image style="width:100px;height:100px" :src=" props.row.commerceVo.headUri === null ? '' : props.row.commerceVo.headUri" fit="contains"></el-image>
                </el-form-item>
                <el-form-item label="是否上架" style="margin-left: 46px">
                  <el-switch v-model="props.row.commerceVo.isSale" active-color="#13ce66" inactive-color="#ff4949" :active-value="1" :inactive-value="0"></el-switch>
                </el-form-item>

              </el-form>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 20, 50, 100]"
                       :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" style="margin-top: 10px"></el-pagination>

        <el-dialog title="商品详情" :visible.sync="dialogVisible" :modal-append-to-body="false">
          <el-descriptions title="产品基础信息">
            <el-descriptions-item label="商品编码">{{currentItem.number}}</el-descriptions-item>
            <el-descriptions-item label="商品名称">{{currentItem.name}}</el-descriptions-item>
            <el-descriptions-item label="规格型号">{{currentItem.model}}</el-descriptions-item>
            <el-descriptions-item label="代号">{{currentItem.shortName}}</el-descriptions-item>
            <el-descriptions-item label="助记码">{{currentItem.helpCode}}</el-descriptions-item>
            <el-descriptions-item label="品牌">{{currentItem.registeredMark}}</el-descriptions-item>
            <el-descriptions-item label="计量单位">{{currentItem.baseUnit}}</el-descriptions-item>
            <el-descriptions-item label="辅助计量单位">{{currentItem.assistUnit}}</el-descriptions-item>
          </el-descriptions>
          <el-divider></el-divider>
          <el-descriptions title="产品销售信息"></el-descriptions>
            <el-form ref="form" :model="currentItem" label-width="80px">
              <el-form-item label="商品名称">
                <el-input v-model="currentItem.commerceVo.name" :disabled="true" style="max-width: 400px"></el-input>
              </el-form-item>
              <el-form-item label="商品标识">
                <el-input v-model="currentItem.commerceVo.nodeIdentify" style="max-width: 400px"></el-input>
              </el-form-item>
              <el-form-item label="商品头图">
                <el-upload class="head-image-uploader" action="https://wellhope.godaji.com/api/osp/materialCommerce/image/upload"
                           :show-file-list="false"
                           :on-success="handleHeadSuccess"
                           :before-upload="beforeHeadUpload">
                  <img v-if="currentItem.commerceVo.headUri" :src="currentItem.resizeHeadUri" class="head-image">
                  <i v-else class="el-icon-plus image-uploader-icon"></i>
                </el-upload>
              </el-form-item>
<!--              <el-form-item label="商品长图">-->
<!--                <el-upload class="head-image-uploader" action="http://localhost:80/api/osp/materialCommerce/image/upload" :show-file-list="false" :on-success="handleBodySuccess" :before-upload="beforeBodyUpload">-->
<!--                  <img v-if="currentItem.commerceVo.bodyUri" :src="currentItem.resizeBodyUri" class="head-image">-->
<!--                  <i v-else class="el-icon-plus image-uploader-icon"></i>-->
<!--                </el-upload>-->
<!--              </el-form-item>-->
              <el-form-item label="轮播图">
                <el-upload
                  class="carousel-upload"
                  action="https://wellhope.godaji.com/api/osp/materialCommerce/image/upload"
                  :on-preview="handlePreview"
                  :on-remove="handleRemove"
                  :on-success="handleSuccess"
                  :file-list="fileList"
                  list-type="picture">
                  <el-button size="small" type="primary">点击上传</el-button>
                  <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500KB</div>
                </el-upload>
              </el-form-item>
              <el-form-item label="商品详情" prop="content" style="line-height: 0">
                <!-- 图片上传组件辅助-->
                <el-upload class="avatar-uploader-editor" :action="serverUrl" name="file" :headers="header" :show-file-list="false"
                           :on-success="uploadSuccess" :on-error="uploadError" :before-upload="beforeUpload"> </el-upload>
                <quill-editor v-model="currentItem.commerceVo.detail" ref="myQuillEditor" style="height: 300px;margin-top: -30px" :options="editorOption">
                  <!-- 自定义toolbar -->
                  <div id="toolbar" slot="toolbar">
                    <!-- Add a bold button -->
                    <button class="ql-bold" title="加粗">Bold</button>
                    <button class="ql-italic" title="斜体">Italic</button>
                    <button class="ql-underline" title="下划线">underline</button>
                    <button class="ql-strike" title="删除线">strike</button>
                    <button class="ql-blockquote" title="引用"></button>
                    <button class="ql-code-block" title="代码"></button>
                    <button class="ql-header" value="1" title="标题1"></button>
                    <button class="ql-header" value="2" title="标题2"></button>
                    <!--Add list -->
                    <button class="ql-list" value="ordered" title="有序列表"></button>
                    <button class="ql-list" value="bullet" title="无序列表"></button>
                    <!-- Add font size dropdown -->
                    <select class="ql-header" title="段落格式">
                      <option selected>段落</option>
                      <option value="1">标题1</option>
                      <option value="2">标题2</option>
                      <option value="3">标题3</option>
                      <option value="4">标题4</option>
                      <option value="5">标题5</option>
                      <option value="6">标题6</option>
                    </select>
                    <select class="ql-size" title="字体大小">
                      <option value="10px">10px</option>
                      <option value="12px">12px</option>
                      <option value="14px">14px</option>
                      <option value="16px" selected>16px</option>
                      <option value="18px">18px</option>
                      <option value="20px">20px</option>
                      <option value="30px">30px</option>
                    </select>
                    <select class="ql-font" title="字体">
                      <option value="SimSun">宋体</option>
                      <option value="SimHei">黑体</option>
                      <option value="Microsoft-YaHei">微软雅黑</option>
                      <option value="KaiTi">楷体</option>
                      <option value="FangSong">仿宋</option>
                      <option value="Arial">Arial</option>
                    </select>
                    <!-- Add subscript and superscript buttons -->
                    <select class="ql-color" value="color" title="字体颜色"></select>
                    <select class="ql-background" value="background" title="背景颜色"></select>
                    <select class="ql-align" value="align" title="对齐"></select>
                    <button class="ql-clean" title="清除字体样式"></button>
                    <button class="ql-image" title="照片"></button>
                  </div>
                </quill-editor>
              </el-form-item>
              <el-form-item label="是否上架" style="margin-top: 60px">
                <el-switch v-model="currentItem.commerceVo.isSale" active-color="#13ce66" inactive-color="#ff4949" :active-value="1" :inactive-value="0"></el-switch>
<!--                <span>{{currentItem.commerceVo.isSale}}</span>-->
              </el-form-item>
              <el-form-item style="margin-left:-80px;text-align: center">
                <el-button type="primary" @click="submitForm()">保存</el-button>
                <el-button type="info" @click="resetForm()">重置</el-button>
              </el-form-item>
            </el-form>
        </el-dialog>
      </el-main>
    </el-main>
  </el-container>
</template>

<script>
import {deleteByIds,updateByBo,saveBo} from "@/api/system/material_group.js";
import {queryPageListByAll} from "../../../api/system/good";
import {getMaterialGroupList, getMaterialLogoList, getMaterialModelList} from "../../../api/system/good";
import {getOrgByAdmin} from "../../../api/system/org_sale";

// 工具栏配置
import {Quill,quillEditor} from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import '@/assets/styles/font.css'
import {getToken} from "../../../utils/auth";

// 自定义字体大小
let Size = Quill.import('attributors/style/size')
Size.whitelist = ['10px', '12px', '14px', '16px', '18px', '20px', '30px']
Quill.register(Size, true)

// 自定义字体类型
let fonts = ['SimSun', 'SimHei', 'Microsoft-YaHei', 'KaiTi', 'FangSong', 'Arial', 'Times-New-Roman', 'sans-serif',
  '宋体', '黑体'
]
let Font = Quill.import('formats/font')
Font.whitelist = fonts
Quill.register(Font, true)

export default {
  components: {
    quillEditor
  },
  data(){
    return {
      currentUser:{},
      saleOrgId:'',
      selectedGroup:'',
      selectedLogo:'',
      selectedModel:'',
      selectedSale:'',
      groupLists:[],
      logoLists:[],
      modelLists:[],
      saleOrgLists:[],
      keyword:'',//关键字搜索
      currentPage:1,
      pageSize:10,
      total:0,
      quillUpdateImg:false,
      serverUrl: 'https://wellhope.godaji.com/api/osp/articleSettings/image/upload',  // 这里写你要上传的图片服务器地址
      header: {token: sessionStorage.token},  // 有的图片服务器要求请求头需要有token
      editorOption: {
        placeholder: "请输入...", //文章初始化提示语
        theme: "snow", // or 'bubble'
        modules: {
          toolbar: {
            container: '#toolbar',
            handlers: {
              'image': function (value) {
                if (value) {
                  // 触发input框选择图片文件
                  document.querySelector('.avatar-uploader-editor input').click()
                } else {
                  this.quill.format('image', false);
                }
              },
            }
          }
        }
      },
      loading:false,


      data:
        [{
        name:'一级',
        children:[{
          name:'二级'
        }]
      }],
      computed:{
      },
      defaultProps:{
        children:'children',
        label:'name'
      },
      tableData:[],
      backTableData:[],
      filtedData:[],
      dialogVisible:false,
      currentItem:{
        name:'',
        number:'',
        shortName:'',
        model:'',
        packagingSpecification:'',
        helpCode:'',
        baseUnit:'',
        registeredMark:'',
        assistUnit:'',
        commerceVo:{
          name:'',
          materialId:'',
          detail:'',
          nodeIdentify:'',
          headUri:'',
          bodyUri:'',
          carouseUris:'',
          isSale:0
        },
        resizeHeadUri:'',
        resizeBodyUri:''
      },
      fileList: [],
      timeLineHeight: "",
      // smallImageProxyBaseUrl : "https://oss.godaji.com:8081/p/rs:fit:100:200/plain/",
      // middleImageProxyBaseUrl : "https://oss.godaji.com:8081/p/rs:fit:400:400/plain/",
      // bigImageProxyBaseUrl : "https://oss.godaji.com:8081/p/rs:fit:800:800/plain/"
    }
  },
  mounted(){
    //获取当前用户
    this.currentUser = this.$store.getters.currentUser
    //获取用户对应销售组织
    this.getOrgByAdmin()
  },
  methods:{
    logout() {
      let that = this;
      that.$modal.confirm('是否确认退出小禾订货平台？').then(function() {
        that.$store.dispatch("LogOut").then(() => {
          that.$store.dispatch("ClearMenu");
          that.$router.push({ path: that.redirect || "/login" }).catch(()=>{});
        }).catch(() => {});
      })
    },
    getOrgByAdmin(){
      let param = {'id':this.currentUser.id}
      getOrgByAdmin(param).then(res => {
        // console.log(res.data)
        this.saleOrgLists = res.data
        this.queryPageListByAll(1)
        this.getMaterialGroupList() //获取分类列表
        this.getMaterialLogoList() //获取品牌列表
        this.getMaterialModelList() //获取规格列表
      }).catch(()=>{

      })
    },
    getMaterialGroupList(){
      let params = {}
      params.orgSales = this.saleOrgLists
      getMaterialGroupList(params).then(res => {
        this.groupLists = res.data
      }).catch(()=>{

      })
    },
    getMaterialLogoList(){
      let params = {}
      params.orgSales = this.saleOrgLists
      getMaterialLogoList(params).then(res => {
        this.logoLists = res.data
      }).catch(()=>{

      })
    },
    getMaterialModelList(){
      let params = {}
      params.orgSales = this.saleOrgLists
      getMaterialModelList(params).then(res => {
        this.modelLists = res.data
      }).catch(()=>{

      })
    },
    handleCheckedItemsChange(value) {
      let checkedCount = value.length;
      this.selectedItems = checkedCount
    },
    handleCheckedSaleChange() {
      this.queryPageListByAll(1)
    },
    handleCheckedGroupChange(){
      this.queryPageListByAll(1)
    },
    handleCheckedLogoChange(){
      this.queryPageListByAll(1)
    },
    handleCheckedModelChange(){
      this.queryPageListByAll(1)
    },
    resetData(){
      this.total = 0
      this.currentPage = 1
      this.pageCount = 1
      // this.pageSize = 10
      this.selectedSale = ''
      this.selectedGroup = ''
      this.selectedLogo = ''
      this.selectedModel = ''
      this.keyword = ''
      this.queryPageListByAll(1)
    },
    handleAvatarSuccess(res, file) {
      this.ruleForm.imgUrl = res.data
      // console.log(this.ruleForm.imgUrl)
      // this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpg" || file.type === "image/png" || file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error('上传图标只能是 JPG或PNG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },
    // 富文本图片上传成功
    uploadSuccess(res,file) {
      let quill = this.$refs.myQuillEditor.quill
      // 如果上传成功
      if (res.code === 200 && res.data !== null) {
        // 获取光标所在位置
        let length = quill.getSelection().index;
        // 插入图片res.url为服务器返回的图片地址
        quill.insertEmbed(length, 'image', res.data)
        // 调整光标到最后
        quill.setSelection(length + 1)
      } else {
        this.$message.error('图片插入失败')
      }
    },
    // 富文本图片上传失败
    uploadError() {
      this.$message.error('图片插入失败')
    },
    beforeUpload(file) {
      const isJPG = file.type === "image/jpg" || file.type === "image/png" || file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error('上传图标只能是 JPG或PNG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },
    queryPageListByAll(val){

      let params = {}
      params.current = val
      params.size = this.pageSize
      params.tenantId = '603609'
      params.name = ''
      params.orgSales = this.saleOrgLists
      //关键字
      params.name = this.keyword

      if(this.selectedSale !== '') {
        params.orgSales = [{'id': this.selectedSale}]
      }
      if(this.selectedGroup !== ''){
        params.groupLists = [{'groupNumber': this.selectedGroup}]
      }
      if(this.selectedLogo !== ''){
        params.logoLists = [{'logoName': this.selectedLogo}]
      }
      if(this.selectedModel !== ''){
        params.modelLists = [{'model': this.selectedModel}]
      }

      this.loading = true
      queryPageListByAll(params).then(res => {
        this.tableData = []
        // console.log(res.data.records);
        if(res.data.records.length > 0){
          // console.log(res.data)
          this.total = res.data.total;
          this.currentPage = res.data.current
          this.pageCount = res.data.pages
          this.pageSize = res.data.size
          this.tableData = res.data.records;
          this.loading = false
        }else{
          this.$modal.msg("没有符合条件的商品")
          this.total = 0
          this.currentPage = 1
          this.pageCount = 1
          this.pageSize = 10
          this.loading = false
        }
      });
    },
    // search(){
    //   if(this.keyword === null || this.keyword === ''){
    //     this.tableData = this.backTableData;
    //     return;
    //   }
    //   this.filtedData = [];
    //   for(let item of this.tableData){
    //     if(item.name !== null && item.name.indexOf(this.keyword) > 0){
    //       this.filtedData.push(item);
    //       continue;
    //     }
    //     if(item.number !== null && item.number.indexOf(this.keyword) > 0){
    //       this.filtedData.push(item);
    //       continue;
    //     }
    //     if(item.shortName !== null && item.number.indexOf(this.keyword) > 0){
    //       this.filtedData.push(item);
    //       continue;
    //     }
    //   }
    //   this.backTableData = this.tableData;
    //   this.tableData = this.filtedData;
    // },
    handleAdd(index , row){
      this.currentItem = row;
      this.currentItem.commerceVo.materialId = this.currentItem.id;
      this.fileList = [];
      this.dialogVisible = true;
    },
    handleEdit(index , row){
      this.currentItem = row;
      //初始化resized头图
      if(this.currentItem.commerceVo.headUri !== null){
        // this.currentItem.resizeHeadUri = this.smallImageProxyBaseUrl + this.currentItem.commerceVo.headUri;
        this.currentItem.resizeHeadUri = this.currentItem.commerceVo.headUri;
      }
      //初始化resized长图
      // if(this.currentItem.commerceVo.bodyUri !== null){
      //   this.currentItem.resizeBodyUri = this.middleImageProxyBaseUrl + this.currentItem.commerceVo.bodyUri;
      // }

      //初始化轮播图
      this.fileList = [];
      if(this.currentItem.commerceVo.carouselUris !== null && this.currentItem.commerceVo.carouselUris !== ''){
        let uris = this.currentItem.commerceVo.carouselUris.split(',');
        // console.log(uris)
        let index = 0;
        for(let item of uris){
          let name = 'image' + index;
          this.fileList.push({name:name , url:item});
          index ++;
        }
      }
      this.dialogVisible = true;
    },
    handleDel(index , row){
      this.$confirm('此操作将永久删除该文件，是否继续?','提示',{
        confirmButtonText:'确定',
        cancelButtonClass:'取消',
        type:'warning'
      }).then((res) => {
        let deleteIds = [];
        if(row.commerceVo.id !== null){
          deleteIds.push(row.commerceVo.id);
        }
        deleteByIds(JSON.stringify(deleteIds)).then(delres => {
          if(delres.data === true){
            this.$message({
              type:'success',
              message:'删除成功！'
            })
            this.queryPageListByAll(1)
          }else{
            this.$message({
              type:'false',
              message:'无电商数据！'
            })
          }
        });
      }).catch((err) =>{
        this.$message({
          type:'info',
          message:'已取消删除'
        })
      })
    },
    handleSizeChange(val){
      this.pageSize = val;
      this.queryPageListByAll(1);
    },
    handleCurrentChange(val){
      this.currentPage = val;
      this.queryPageListByAll(val);
    },
    handleHeadSuccess(res , file){
      // console.log(res)
      this.currentItem.commerceVo.headUri = res.data;
      this.currentItem.resizeHeadUri = res.data;
      // this.currentItem.resizeHeadUri = this.smallImageProxyBaseUrl + res.data;
      // console.log(this.currentItem.commerceVo.headUri)
      // console.log(this.currentItem.resizeHeadUri)
    },
    beforeHeadUpload(file){
      this.isImageValid(file);
    },
    // handleBodySuccess(res , file){
    //   this.currentItem.commerceVo.bodyUri = res.data;
    //   this.currentItem.resizeBodyUri = this.middleImageProxyBaseUrl + res.data;
    // },
    // beforeBodyUpload(file){
    //   this.isImageValid(file);
    // },
    isImageValid(file){
      const isJPG = file.type === 'image/jpeg' || file.type === "image/jpeg" || file.type === "image/png";
      const isLt4M = file.size / 1024 / 1024 < 4;
      if(!isJPG){
        this.$message.error('上传图片只能是 JPG或PNG 格式！');
      }
      if(!isLt4M){
        this.$message.error('上传图片不能超过4MB！');
      }
      return isJPG && isLt4M;
    },
    handleRemove(file, fileList){
      this.currentItem.commerceVo.carouselUris = ''
      for(let i = 0; i < fileList.length; i++){
        if(i === 0){
          this.currentItem.commerceVo.carouselUris = fileList[0].url
        }else{
          this.currentItem.commerceVo.carouselUris += ',' + fileList[i].url
        }
      }
    },
    handlePreview(file){
      console.log(file.url);
    },
    handleSuccess(file,fileList){
      if(this.currentItem.commerceVo.carouselUris == null || this.currentItem.commerceVo.carouselUris === ''){
        this.currentItem.commerceVo.carouselUris = file.data
      }else{
        this.currentItem.commerceVo.carouselUris += ',' + file.data
      }
    },
    submitForm(){
      this.currentItem.commerceVo.carouseUris = this.fileList
      if(this.currentItem.commerceVo.id === undefined || this.currentItem.commerceVo.id === null){
        saveBo(JSON.stringify(this.currentItem.commerceVo)).then(saveRes => {
          if(saveRes.msg === 'ok'){
            this.currentItem.commerceVo.id = saveRes.data;
            this.$message({
              type:'success',
              message:'保存成功！'
            });
            this.dialogVisible = false;
            this.queryPageListByAll(1);
          }else{
            this.$message({
              type:'false',
              message:'保存失败,' + saveRes.msg
            })
          }
        }).catch(saveRes => {
          this.$message({
            type:'info',
            message:'已取消保存！'
          })
        });

      }else{
        //update
        updateByBo(JSON.stringify(this.currentItem.commerceVo)).then(updateRes => {
          if(updateRes.msg === 'ok'){
            this.$message({
              type:'success',
              message:'更新成功！'
            })
            this.dialogVisible = false;
            this.queryPageListByAll(1);
          }else{
            this.$message({
              type:'false',
              message:'更新失败,' + updateRes.msg
            })
          }
        }).catch(updateRes => {
          this.$message({
            type:'info',
            message:'已取消更新！'
          })
        });
      }
    },
    resetForm(){
      this.currentItem.commerceVo.headUri = '';
      // this.currentItem.commerceVo.bodyUri = '';
      this.currentItem.commerceVo.carouseUris = '';
      this.fileList = [];
      this.currentItem.commerceVo.isSale = 0;
      this.currentItem.commerceVo.name = '';
      this.currentItem.commerceVo.detail = '';
      this.currentItem.commerceVo.nodeIdentify = '';
    }
  }
}
</script>

<style scoped>
  .company{
    font-size: 14px;
    color:rgb(143, 143, 143);
  }
  .but3{
    font-size: 14px;
    color: rgb(240, 57, 74);
    border: none;
    background: white;
    font-weight: 600;
  }
  .div_top{
    margin: 12px 0;
  }
  .main{
    overflow: auto;
    height: 86vh;
    margin-top: -10px;
  }
  .three_lever{
    width: 18px;
    height: 20px;
    display: flex;
    margin-top: 3px;
    margin-right: 10px;
  }
  .text{
    display: flex;
    color: rgb(239, 51, 69);
    font-size: 20px;
    font-weight: 700;
    line-height: 25px;
    letter-spacing: 1px;
    text-align: left;
    /*margin: 0 8px;*/
  }
  .query{
    width: 100%;
    /*height: 250px;*/
    box-sizing: border-box;
    border: 1px solid rgb(196, 196, 196);
    margin-top: 10px;
  }
  .avatar-uploader >>> .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader >>> .el-upload:hover {
    border-color: #409EFF;
  }
  .head-image {
    width: 120px;
    height: 120px;
    display: block;
  }


.table-expand{
  font-sie:0;
}
.table-expand label{
  width: 90px;
  color: #8d9bb3;
}
/*.table-expand .el-form-item{*/
/*  margin-right: 0;*/
/*  margin-bottom: 0;*/
/*  width:50%;*/
/*}*/
.head-image-uploader >>> .el-upload{
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.head-image-uploader .el-upload:hover{
  border-color: #409EFF;
}
  .image-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 120px;
    height: 120px;
    line-height: 120px;
    text-align: center;
  }
</style>

